import type { MsAdlActivityLabels } from "../en-GB/msAdlCopy";

export const msAdlCopyFr: MsAdlActivityLabels = {
    Walking: "Marche",
    Cooking: "Cuisine",
    Driving: "Conduite",
    Shopping: "Courses",
    Work: "Travail",
    Sport: "Sport",
    Housework: "Tâches ménagères",
    Socialising: "Vie sociale",
};
